import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import * as fromRootStore from "../../../reducers";
import { Combo2Service, ExcelService, PurchaseReportService } from "../../../services/index";
import { PurchaseOrderService } from "../../../services/purchaseorder.service";
declare var google;

@Component({
  selector: "grn",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./grnReport.html",
})
export class GrnReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  gridOptions: any;
  dataList = [];
  qualityList: any;
  typeList: any;
  exceldata: any;
  colorList: any;
  codeList: any;
  widthList: any[];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  finyearList = [];
  groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  grnList = ["SAMPLE", "BULK", "MATCHING", "SWATCH"];
  filter = {
    groupby: "GRN",
    party_code: "",
    party_name: "",
    fin_id: "",
    party_id: "",
    agent: "",
    transport: "",
    color: [],
    design_no: "",
    design_type: [],
    shade: "",
    width: [],
    quality: [],
    type: [],
    sample_cut: [],
    swatch_cut: [],
    rcvd_type: [],
    grn_from_date: "",
    grn_to_date: "",
    rate_from: "",
    rate_to: "",
    grn_from: "",
    grn_to: "",
    mtr_from: "",
    mtr_to: "",
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "grn_no",
    orderDir: "desc",
  };
  printConfig: any = {
    title: "GRN Report",
    columns: [],
    rows: [],
  };

  partyList = [];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;
  @ViewChild("grntype") grntype;

  finyearCtrl: FormControl = new FormControl();
  grntypeCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  columns = [];
  partycodeList = [];
  toggleCol = [];
  menu: any;
  reportTypeList = ["DESIGN NO", "PARTY", "GRN"];
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  corenewlist = [];
  rcvdList = ["LR", "COU", "HD"];
  sampList = ["YES", "NO"];
  coreNew : boolean;
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  threeMonthBeforeDate: any;
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    private excelService: ExcelService,
    private combo2Service: Combo2Service,
    public toasterService: ToasterService,
    private poservice: PurchaseOrderService,
    private purService: PurchaseReportService
  ) {
    var d = new Date();
    this.threeMonthBeforeDate = d.setMonth(d.getMonth() - 3);
    this.filter.grn_from_date = this.threeMonthBeforeDate;
  }

  ngOnInit(): void {
    if (this.menu.param == "GangCore") {
      this.corenewlist = ["CORE", "GANG"];
      this.filter.design_type = ["CORE"];
    } else {
      this.corenewlist = ["NEW", "ALL"];
      this.filter.design_type = ["NEW"];
    }
    this.getColumns();
    this.finyearCombo();
    this.codelist();
    this.colorlist();
    this.widthlist();
    this.qualitylist();
    this.typelist();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        type: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center",
        headerClass: "text-center",
      },
      {
        name: "PO No",
        prop: "po_no",
        cellClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center",
      },
      {
        name: "Date",
        prop: "po_date",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        headerClass: "text-center",
      },
      {
        name: "Party Code",
        prop: "party_code",
        minWidth: 160,
        maxWidth: 160,
        width: 160,
        headerClass: "text-center",
      },
      {
        name: "Party Name",
        prop: "party_name",
        minWidth: 160,
        maxWidth: 160,
        width: 160,
        headerClass: "text-center",
      },
      {
        name: "Indent No",
        prop: "indent_no",
        cellClass: "text-right",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        headerClass: "text-center",
      },
      {
        name: "Transport",
        prop: "transport",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        headerClass: "text-center",
      },
      {
        name: "Agent",
        prop: "agent",
        cellClass: "text-right",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        headerClass: "text-center",
      },
      {
        name: "Total Amount",
        prop: "total_amount",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
      {
        name: "No of Designs",
        prop: "no_of_design",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
    ];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    //this.getGrnList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getGrnList();
  }

  loadSeasonList() {
    let that = this;
    this.combo2Service.seasonCombo().then(function (res) {
      //  this.LoadAgentList();
      that.seasonList = res.data;
      that.seasonCtrl.setValue(res.data[0].season_id);
    });
  }

  onClickcolor(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter.color = selected;
      //this.fil['brand'] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }

  onClickwidth(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter.width = selected;
      //this.fil['brand'] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }

  onClickquality(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter.quality = selected;
      //this.fil['brand'] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }
  onClicktype(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter.type = selected;
      //this.fil['brand'] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }

  onClickRcvd(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter.rcvd_type = selected;
      //this.fil['brand'] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }
  onClickdesigntype(selected, name, status) {
    let exists = this.filter.design_type.findIndex(el => el == name);
    if (status == true && exists == -1) {
      selected.push(name);
      this.filter.design_type = selected;
      //this.fil['brand'] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }
  onSelectParty($event) {
    let party_id = $event.item.party_id;
    this.filter.party_id = party_id;
  }

  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.finyearCtrl.setValue(res.data[0].fin_id);
      this.getGrnList();
    });
  }

  qualitylist() {
    this.poservice.qualitylist({}).then((res: any) => {
      this.qualityList = res.data;
    });
  }

  typelist() {
    this.poservice.typelist({}).then((res: any) => {
      this.typeList = res.data;
    });
  }
  colorlist() {
    this.poservice.colorlist({}).then((res: any) => {
      this.colorList = res.data;
    });
  }
  widthlist() {
    this.poservice.widthlist({}).then((res: any) => {
      this.widthList = res.data;
    });
  }

  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }

  codelist() {
    this.poservice.codelist({}).then((res: any) => {
      this.partycodeList = res.data;
    });
  }
  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  onbackbutton() {
    this.filter.groupby = "DESIGN NO";
    this.filter.design_no = "";

    this.getGrnList();
  }

  onCellClick(event) {
    let row = event.row;
    let mode = 'View';
    // this.filter.groupby = "DESIGN SHADE";
    // this.filter.design_no = event.row.des_no;
    // let params = {
    //   filter: JSON.stringify(this.filter),
    // };
    // let that = this;
    // that.isLoadMask = that.purService
    //   .getGrnReport(params)
    //   .then(function (res: any) {
    //     that.gridOptions = {
    //       cols: res.cols,
    //       columns: res.columns,
    //       data: res.data,
    //       loading: false,
    //     };
    //   });

    this.filterExpand = true;
    let listUpdateEvent = new EventEmitter();
    row.tabevent = listUpdateEvent;
    let tabObj = {};
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "VIEW GRN",
          title: "VIEW GRN",
          tabParent: "CLOTH",
          mode: mode,
          data: row,
          name: "AddEditGrn",
        },
      };

    this.tabUpdateEvent.emit(tabObj);
  }

  getGrnList(): void {
    this.filter.grn_from_date = this.datePipe.transform(
      this.filter.grn_from_date,
      "yyyy-MM-dd"
    );
    this.filter.grn_to_date = this.datePipe.transform(
      this.filter.grn_to_date,
      "yyyy-MM-dd"
    );
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(this.filter),
    };
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
    };
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.purService
      .getGrnReport(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;

        that.gridOptions = {
          cols: res.cols,
          columns: res.columns,
          data: res.data,
          loading: false,
        };
        that.printConfig = {
          title: "GRN Report",
          columns: res.columns,
          rows: that.orderList,
        };
        that.exceldata = that.getData(res.columns, res.data);
      });
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  refreshData() {
    let columns = this.columns,
      data = this.dataList,
      row = this.getSummaryRow(data, columns);
    data.push(row);
    this.page.count = data.length;
    // this.dataList = data;
  }

  getSummaryRow(data, columns) {
    let row = {
      type: "summary",
    };
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j];
            total += dat[col.prop];
          }
          row[col.prop] = Math.round(total * 100) / 100;
          break;
        default:
          row[col.prop] = "";
          break;
      }
    }
    return row;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/grnReport/grnReport.ts